import { z } from 'zod';

export enum OperaAuthMethod {
  RESOURCE_BASED = 'resource-based',
  CLIENT_CREDENTIALS = 'client-credentials',
}

export const OperaHotelDetailsSchema = z.object({
  region: z.string(),
  tenantCode: z.string(),
  hotelId: z.string(),
  ssdUrl: z.string(),
});

const OperaResourceBasedCredentialsSchema = OperaHotelDetailsSchema.extend({
  authMethod: z.literal(OperaAuthMethod.RESOURCE_BASED).default(OperaAuthMethod.RESOURCE_BASED),
  appKey: z.string(),
  host: z.string(),
  // Optional OAuth gateway. Opera Cloud issues tokens against a region-specific
  // gateway that can differ from the API gateway (e.g. Auberge shares one client
  // ID across NA/EU and must authenticate against NA). When unset, token requests
  // fall back to `host`, preserving single-URL connections.
  authUrl: z.string().optional(),
  clientId: z.string(),
  clientSecret: z.string(),
  extSystemCode: z.string(),
  username: z.string(),
  password: z.string(),
});

const OperaClientCredentialsSchema = OperaHotelDetailsSchema.extend({
  authMethod: z.literal(OperaAuthMethod.CLIENT_CREDENTIALS),
  appKey: z.string(),
  host: z.string(),
  authUrl: z.string().optional(),
  clientId: z.string(),
  clientSecret: z.string(),
  extSystemCode: z.string(),
  enterpriseId: z.string(),
});

export const OperaCredentialsSchema = z.union([OperaResourceBasedCredentialsSchema, OperaClientCredentialsSchema]);
export type OperaCredentials = z.output<typeof OperaCredentialsSchema>;
